import React from 'react';
import { Menu } from 'antd';

const ChatMenuGroup = ({ title, chats = [], onChatClick, icon, index }) => (
  <Menu.ItemGroup title={<span style={{ fontSize: '1rem', color: '#000' }}>{title}</span>}>
    {chats.map((chat, index) => (
      <Menu.Item
        key={String(chat.id)}
        onClick={() => onChatClick?.(chat?.id)}
        icon={icon}
        style={{
          padding: '0.25rem 0.5rem',
          borderRadius: '0.25rem',
          cursor: 'pointer',
        }}
      >
        {chat?.title || chat.name || 'Untitled'}
      </Menu.Item>
    ))}
  </Menu.ItemGroup>
);

export default ChatMenuGroup;
